import { render } from "./WwtpCard.vue?vue&type=template&id=7d54e808&scoped=true"
import script from "./WwtpCard.vue?vue&type=script&lang=js"
export * from "./WwtpCard.vue?vue&type=script&lang=js"

import "./WwtpCard.vue?vue&type=style&index=0&id=7d54e808&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d54e808"]])

export default __exports__